module.exports = __webpack_public_path__ + "images/greenlab-950b4b85e09f12467e02d15a6d9aae3a.jpg";